// Restoran Ekranları listesi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.restaurantPage';

export const salesRestaurantPageGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Restoran Ekranları nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Her restoran ekranı bir salonun masa planıdır: masaları, garsonları, kasiyerleri ve ödeme ayarları bu ekrana bağlıdır. Buradan ekran oluşturur, ayarlarını yapar ve ekranı açarsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    toolbar: t(`${G}.regions.toolbar`, '+ Restoran Ekranı ve ⋮'),
    filters: t(`${G}.regions.filters`, 'Arama ve şube'),
    table: t(`${G}.regions.table`, 'Restoran ekranları'),
  },
  steps: [
    {
      region: 'toolbar',
      title: t(`${G}.s1.title`, '1. Restoran ekranı oluşturun'),
      text: t(`${G}.s1.text`, '"+ Restoran Ekranı" düğmesi "Yeni Restoran Ekranı Oluştur" penceresini açar. "Ekran Adı / Tanımlayıcı" alanını doldurun (örn: Restoran 1 - Ana Salon), isterseniz "Atanan Şube (Opsiyonel)" ile bir şube seçin ve "Oluştur"a basın.'),
      tips: [
        t(`${G}.s1.tip1`, 'Ekran adı zorunludur; boş bırakılırsa kayıt yapılmaz.'),
        t(`${G}.s1.tip2`, 'Şube seçilmezse listede "Şube Atanmamış" yazar.'),
        t(`${G}.s1.tip3`, 'Adı veya şubeyi sonradan değiştirmek için satırdaki ⋮ → "Düzenle" yolunu kullanıp "Güncelle"ye basın.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s2.title`, '2. Masa gruplarını ve masaları tanımlayın'),
      text: t(`${G}.s2.text`, 'Satırdaki ⋮ → "Ayarlar" restoran ayarları penceresini açar. "Masa Grupları" sekmesinde Salon, Bahçe gibi grupları, "Masalar" sekmesinde masaları ekleyin. Masa tanımlanmadan restoran ekranında masa görünmez.'),
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Garson, kasiyer ve ödeme ayarlarını yapın'),
      text: t(`${G}.s3.text`, 'Aynı pencerede "Garson Atama" ve "Kasiyer Atama" sekmelerinde ekrana kimlerin şifreyle girebileceğini ve neler yapabileceğini belirleyin. "Ödeme Yöntemleri", "Depo/Stok", "Yazdırma" ve "Ek Ayarlar" gibi sekmeler satış ve fiş ayarlarını içerir.'),
      tips: [
        t(`${G}.s3.tip1`, 'Ürün silme, masa aktarma, adisyon yazdırma, adisyon iptali gibi işlemler garsona verilen yetkilere bağlıdır; yetkisi olmayan garsonun düğmesi pasif görünür.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. "Masalar" ile ekranı açın'),
      text: t(`${G}.s4.text`, 'Satırdaki "Masalar" düğmesi restoran ekranını (masa planını) açar. Ekran kilitli açılır; garson veya kasiyer kendi şifresiyle giriş yapar ve masalara dokunarak sipariş alır.'),
    },
    {
      region: 'filters',
      title: t(`${G}.s5.title`, '5. Ekranı bulun'),
      text: t(`${G}.s5.text`, 'Çok sayıda ekranınız varsa arama kutusuna ekran adını yazın veya "Şube Filtresi" ile listeyi daraltın. "Şubeye Ait Değil" seçeneği şubesiz ekranları gösterir.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s6.title`, '6. Raporlar ve ekran silme'),
      text: t(`${G}.s6.text`, 'Başlıktaki ⋮ menüsünde "Sipariş Raporları", "Gün Sonu Raporu" ve "Gün Sonları Listesi" bulunur. Bir ekranı kaldırmak için satırdaki ⋮ → "Sil" yolunu kullanın.'),
      tips: [
        t(`${G}.s6.tip1`, 'Silme işlemi geri alınamaz; silmeden önce onay sorulur.'),
        t(`${G}.s6.tip2`, 'Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
      ],
    },
  ],
});
